import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 2 }
const _hoisted_2 = {
  key: 3,
  class: "mt-2"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Перевозка", -1)
const _hoisted_4 = { class: "flex items-center mt-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold mt-2 mb-1" }, "Дополнительные услуги", -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "font-semibold mb-2" }
const _hoisted_8 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "font-semibold mb-2" }
const _hoisted_11 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_12 = {
  key: 2,
  class: "mt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_radio_group = _resolveComponent("radio-group")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "xxl",
    title: "Заполните данные о доставке",
    loading: _ctx.isModalLoading,
    scrollable: "",
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.manageSubmitted
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        class: "w-full mt-2",
        type: "date",
        placeholder: "Дата доставки",
        value: _ctx.delivery_state.delivery_date,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.delivery_state.delivery_date) = $event)),
        "is-invalid": _ctx.state_form$.delivery_date.$error,
        "validation-errors": _ctx.state_form$.delivery_date.$errors
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        class: "w-full mt-2",
        placeholder: "Время доставки",
        maska: _ctx.TIME_MASK,
        value: _ctx.delivery_state.delivery_time,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.delivery_state.delivery_time) = $event)),
        "is-invalid": _ctx.state_form$.delivery_time.$error,
        "validation-errors": _ctx.state_form$.delivery_time.$errors
      }, null, 8, ["maska", "value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        class: "w-full mt-2",
        placeholder: "ФИО принявшего заказ",
        value: _ctx.delivery_state.received_by,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.delivery_state.received_by) = $event)),
        "is-invalid": _ctx.state_form$.received_by.$error,
        "validation-errors": _ctx.state_form$.received_by.$errors
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      (_ctx.ftlType === 0)
        ? (_openBlock(), _createBlock(_component_file_reader, {
            key: 0,
            class: "mt-3",
            accept: "image/*",
            placeholder: "ТТН",
            value: _ctx.delivery_state.ttn,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.delivery_state.ttn) = $event)),
            "is-invalid": _ctx.state_form$.ttn.$error,
            "validation-errors": _ctx.state_form$.ttn.$errors,
            multiple: ""
          }, null, 8, ["value", "is-invalid", "validation-errors"]))
        : _createCommentVNode("", true),
      (_ctx.ftlType === 1)
        ? (_openBlock(), _createBlock(_component_file_reader, {
            key: 1,
            class: "mt-3",
            accept: "image/*",
            placeholder: "CMR",
            value: _ctx.delivery_state.cmr,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.delivery_state.cmr) = $event)),
            "is-invalid": _ctx.state_form$.cmr.$error,
            "validation-errors": _ctx.state_form$.cmr.$errors,
            multiple: ""
          }, null, 8, ["value", "is-invalid", "validation-errors"]))
        : _createCommentVNode("", true),
      (_ctx.isFTLTypeOne)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_file_reader, {
              class: "mt-3",
              placeholder: "Фото снятой пломбы",
              accept: "image/*",
              value: _ctx.delivery_state.removed_stamp,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.delivery_state.removed_stamp) = $event)),
              "is-invalid": _ctx.state_form$.removed_stamp.$error,
              "validation-errors": _ctx.state_form$.removed_stamp.$errors,
              multiple: ""
            }, null, 8, ["value", "is-invalid", "validation-errors"]),
            _createVNode(_component_file_reader, {
              class: "mt-3",
              placeholder: "Фото открытого кузова",
              accept: "image/*",
              value: _ctx.delivery_state.carcass,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.delivery_state.carcass) = $event)),
              "is-invalid": _ctx.state_form$.carcass.$error,
              "validation-errors": _ctx.state_form$.carcass.$errors,
              multiple: ""
            }, null, 8, ["value", "is-invalid", "validation-errors"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isFTLTypeTwo() && _ctx.isNeedCar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_the_input, {
                class: "w-full",
                placeholder: "Количество авто",
                value: _ctx.delivery_state.auto_count,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.delivery_state.auto_count) = $event)),
                "is-invalid": _ctx.state_form$.auto_count.$error,
                "validation-errors": _ctx.state_form$.auto_count.$errors
              }, null, 8, ["value", "is-invalid", "validation-errors"]),
              _createVNode(_component_the_input, {
                class: "w-full ml-2",
                placeholder: "Отработанные часы для себестоимости",
                value: _ctx.delivery_state.auto_duration,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.delivery_state.auto_duration) = $event)),
                "is-invalid": _ctx.state_form$.auto_duration.$error,
                "validation-errors": _ctx.state_form$.auto_duration.$errors
              }, null, 8, ["value", "is-invalid", "validation-errors"])
            ]),
            _createVNode(_component_the_input, {
              class: "mt-3",
              placeholder: "Отработанные часы для выставления",
              value: _ctx.delivery_state.auto_duration_client,
              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.delivery_state.auto_duration_client) = $event)),
              "is-invalid": _ctx.state_form$.auto_duration_client.$error,
              "validation-errors": _ctx.state_form$.auto_duration_client.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        (!_ctx.isOnTheWay)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_5,
              (_ctx.isHaveAdditionalServices)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("p", _hoisted_7, "Отправной пункт: " + _toDisplayString(_ctx.senderCity || '-'), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delivery_state.additional_services, (service, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `service-${idx}`,
                        class: "flex flex-col mb-3 border rounded-sm p-3"
                      }, [
                        _createElementVNode("p", null, _toDisplayString(service.type_name), 1),
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_the_select, {
                            class: "mt-2",
                            value: service.carrier_id,
                            "onUpdate:value": ($event: any) => ((service.carrier_id) = $event),
                            "is-invalid": 
                                    _ctx.state_form$.additional_services.$each.$response.$data[idx]
                                        .carrier_id?.$invalid
                                ,
                            placeholder: "Выберите перевозчика",
                            label: "name",
                            "search-by": "name",
                            "select-by": "id",
                            options: _ctx.data_state.list,
                            loading: _ctx.data_state.is_loading,
                            failed: _ctx.data_state.is_failed,
                            "error-text": "При получении списка перевозчиков произошла ошибка",
                            "infinite-scroll": "",
                            onRefresh: _cache[10] || (_cache[10] = ($event: any) => (_ctx.loadCarriers(_ctx.data_state.pagination.current_page))),
                            onLoadmore: _cache[11] || (_cache[11] = ($event: any) => (_ctx.loadMoreCarriers(_ctx.data_state.pagination.current_page + 1)))
                          }, null, 8, ["value", "onUpdate:value", "is-invalid", "options", "loading", "failed"]),
                          _createVNode(_component_the_input, {
                            placeholder: "Себестоимость за час",
                            value: service.cost_per_hour,
                            "onUpdate:value": ($event: any) => ((service.cost_per_hour) = $event),
                            "is-invalid": 
                                    _ctx.state_form$.additional_services.$each.$response.$data[idx]
                                        .cost_per_hour?.$invalid
                                
                          }, null, 8, ["value", "onUpdate:value", "is-invalid"]),
                          (_ctx.isHaveValue(service.type_id))
                            ? (_openBlock(), _createBlock(_component_the_input, {
                                key: 0,
                                placeholder: "Количество",
                                value: service.value,
                                "onUpdate:value": ($event: any) => ((service.value) = $event),
                                "is-invalid": 
                                    _ctx.state_form$.additional_services.$each.$response.$data[idx].value
                                        ?.$invalid
                                
                              }, null, 8, ["value", "onUpdate:value", "is-invalid"]))
                            : _createCommentVNode("", true),
                          (_ctx.isHaveDuration(service.type_id))
                            ? (_openBlock(), _createBlock(_component_the_input, {
                                key: 1,
                                placeholder: "Общее затраченное время",
                                value: service.duration,
                                "onUpdate:value": ($event: any) => ((service.duration) = $event),
                                "is-invalid": 
                                    _ctx.state_form$.additional_services.$each.$response.$data[idx]
                                        .duration?.$invalid
                                
                              }, null, 8, ["value", "onUpdate:value", "is-invalid"]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isHaveAdditionalServicesStock)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stocks, (stock, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `service-delivery-${i}`,
                        class: "flex flex-col mb-3"
                      }, [
                        _createElementVNode("p", _hoisted_10, "Пункт: " + _toDisplayString(stock.directionName || '-'), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delivery_state.additional_services_stock[i], (service, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `service-delivery-${idx}`,
                            class: "flex flex-col mb-3 border rounded-sm p-3"
                          }, [
                            _createElementVNode("p", null, _toDisplayString(service.type_name), 1),
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(_component_the_select, {
                                class: "mt-2",
                                value: service.carrier_id,
                                "onUpdate:value": ($event: any) => ((service.carrier_id) = $event),
                                "is-invalid": !service.carrier_id,
                                placeholder: "Выберите перевозчика",
                                label: "name",
                                "search-by": "name",
                                "select-by": "id",
                                options: _ctx.data_state.list,
                                loading: _ctx.data_state.is_loading,
                                failed: _ctx.data_state.is_failed,
                                "error-text": "При получении списка перевозчиков произошла ошибка",
                                "infinite-scroll": "",
                                onRefresh: _cache[12] || (_cache[12] = ($event: any) => (_ctx.loadCarriers(_ctx.data_state.pagination.current_page))),
                                onLoadmore: _cache[13] || (_cache[13] = ($event: any) => (
                                        _ctx.loadMoreCarriers(_ctx.data_state.pagination.current_page + 1)
                                    ))
                              }, null, 8, ["value", "onUpdate:value", "is-invalid", "options", "loading", "failed"]),
                              _createVNode(_component_the_input, {
                                placeholder: "Себестоимость за час",
                                value: service.cost_per_hour,
                                "onUpdate:value": ($event: any) => ((service.cost_per_hour) = $event),
                                "is-invalid": !service.cost_per_hour
                              }, null, 8, ["value", "onUpdate:value", "is-invalid"]),
                              (_ctx.isHaveValue(service.type_id))
                                ? (_openBlock(), _createBlock(_component_the_input, {
                                    key: 0,
                                    placeholder: "Количество",
                                    value: service.value,
                                    "onUpdate:value": ($event: any) => ((service.value) = $event),
                                    "is-invalid": !service.value
                                  }, null, 8, ["value", "onUpdate:value", "is-invalid"]))
                                : _createCommentVNode("", true),
                              (_ctx.isHaveDuration(service.type_id))
                                ? (_openBlock(), _createBlock(_component_the_input, {
                                    key: 1,
                                    placeholder: "Общее затраченное время",
                                    value: service.duration,
                                    "onUpdate:value": ($event: any) => ((service.duration) = $event),
                                    "is-invalid": !service.duration
                                  }, null, 8, ["value", "onUpdate:value", "is-invalid"]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.isOnTheWay || _ctx.isCrossed)
          ? (_openBlock(), _createBlock(_component_checkbox, {
              key: 1,
              label: "Простой",
              class: "mt-3",
              value: _ctx.delivery_state.has_downtime,
              "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.delivery_state.has_downtime) = $event)),
              disabled: _ctx.isModalLoading
            }, null, 8, ["value", "disabled"]))
          : _createCommentVNode("", true),
        (_ctx.delivery_state.has_downtime)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_radio_group, {
                name: "shipment_type",
                value: _ctx.delivery_state.downtime.type,
                "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.delivery_state.downtime.type) = $event)),
                options: _ctx.FTL_ORDER_PAYMENT_RATE_TYPES,
                class: "small"
              }, null, 8, ["value", "options"]),
              _createVNode(_component_the_input, {
                class: "mt-3",
                placeholder: "Кол-во часов простоя для себестоимости",
                value: _ctx.delivery_state.downtime.hours,
                "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.delivery_state.downtime.hours) = $event)),
                "is-invalid": _ctx.state_form$.downtime.hours.$error,
                "validation-errors": _ctx.state_form$.downtime.hours.$errors
              }, null, 8, ["value", "is-invalid", "validation-errors"]),
              _createVNode(_component_the_input, {
                class: "mt-3",
                placeholder: _ctx.getPlaceholder('Себестоимость простоя'),
                value: _ctx.delivery_state.downtime.cost_price,
                "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.delivery_state.downtime.cost_price) = $event)),
                "is-invalid": _ctx.state_form$.downtime.cost_price.$error,
                "validation-errors": _ctx.state_form$.downtime.cost_price.$errors
              }, null, 8, ["placeholder", "value", "is-invalid", "validation-errors"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}